import axios from "../../../axios";

export const getInstances = async (id,payload) => {
    try{        
        let { data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/bot/instance/?bot_id=${id}&limit=${payload.limit}&offset=${payload.offSet}`);               
        return data;
       }catch(e){
        console.log("errors", e)
    } 
}

export const getSearchInstances = async (id,payload) => {
    try{        
        let { data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/bot/instance/queueid/?bot_id=${id}&queue_id=${payload}`);               
        return data;
       }catch(e){
        console.log("errors", e)
    } 
}
